
<template>
  <div>
    <div class="list-area">
      <div v-if="noData" class="no-contents">조회 결과가 없습니다</div>
      <vertical-list-slider
        :listItems="listItems"
        :componentStyle="componentStyle"
        :isActiveVue="isActiveVue"
        @loadMore="loadMore"
      ></vertical-list-slider>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import VerticalListSlider from "../components/slider/VerticalListSlider.vue";

export default {
  data() {
    return {
      isActiveVue: true,
      componentStyle: {
        width: Number(window.innerWidth) == 1920 ? "358px" : "244px",
        height: Number(window.innerWidth) == 1920 ? "312px" : "233px",
        left: Number(window.innerWidth) == 1920 ? "440px" : "312px",
      },
      noData: false,
      pageNo: 1,
      pageItem: 4,
      count: 0,
      isLoading: true,
    };
  },

  computed: {
    seasonList() {
      return this.$store.getters.leagueSeasonList;
    },
    yearList() {
      return this.$store.getters.yearList
    },
    listItems() {
      return this.$store.getters.leagueVodList;
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
  },

  watch: {
    fousedView(val) {
      if (this.isActiveVue == true && val == "default" && this.noData == true) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      }
    },
  },

  components: {
    VerticalListSlider,
  },
  
  methods: {
    async getData() {
      let params = {
        gameType: this.$route.params.gameTypeId,
        leagueId: this.$route.params.leagueId,
        teamId: null,
        seasonId: null,
        roundId: null,
        year: null,
        page: this.pageNo,
        pageItem: this.pageItem,
      }

      let { gameTypeId } = this.$route.params

      if (gameTypeId == 2 || gameTypeId == 8) {
        params.year = this.$route.params.year || this.yearList[0].year
      } else {
        params.seasonId = this.$route.params.seasonId || this.seasonList.list[0].id
      }

      this.$progress.$emit("on:progress");
      this.isLoading = true
      await this.$store.dispatch("FETCH_LEAGUE_VOD_LIST", params).then((response) => {
        if (!response || !response.data || response.data.count < 1) {
          this.noData = true
          this.$store.commit("SET_FOCUSED_VIEW", "gnb")
        } else {
          this.count = response.data.count
        }
      }).finally((r) => {
        this.$progress.$emit("off:progress");
        this.isLoading = false
      })
    },
    loadMore() {
      if(Math.ceil(this.count/this.pageItem) > this.pageNo && !this.isLoading && !this.noData) {
        this.pageNo += 1
        this.getData()
      }
    }
  },

  created() {
    this.$store.commit("SET_FOCUSED_VIEW", "default");
    this.$store.commit("REMOVE_LEAGUE_VOD_LIST");
    this.$store.commit("REMOVE_LEAGUE_SEASON_LIST");
    this.$store.commit("REMOVE_YEAR_DATA");

    let dispathchType = "";
    let { gameTypeId } = this.$route.params

    if (gameTypeId == 2 || gameTypeId == 8) {
      dispathchType = "FETCH_YEAR_DATA_BY_LEAGUEID";
    } else {
      dispathchType = "FETCH_LEAGUE_SEASON_LIST";
    }

    this.$store
      .dispatch(dispathchType, this.$route.params)
      .then((response) => {
        if (!response || !response.data || response.data.length <= 0 ) {
          this.noData = true
          this.$store.commit("SET_FOCUSED_VIEW", "gnb")
        } else {
          this.getData()
        }
      })
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.list-area {
  position: relative;
}
.no-contents {
  font-size: 32px;
  left: 900px;
  top: 460px;
  width: 400px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: rgba(30, 30, 30, 0.95);
}
.focused {
  border: solid 4px #eeeeee;
}

@media all and (min-width:0px) and (max-width:1280px){
  .list-area {
    position: relative;
    width: 100vw;
    height: 100vh;
  }

  .no-contents {
    font-size: 32px;
    top: 460px;
    width: 400px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: rgba(30, 30, 30, 0.95);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>